
import commonServices from "components/Common/commonServices"
import { useState } from "react"
import Modal from "react-responsive-modal"

export default function SearchCurrency(param: any) {


    const closePage = (e: any) => { param.Closecurrency(e) }

    const [totalRows, settotalRows] = useState(0);
    const [searchFor, settsearchFor] = useState('');
    const [currencyListing, setcurrencyListing] = useState<any>([]);
    const SearchData = () => {
        commonServices.currencyListing({ territory: searchFor }).then((values: any) => {
            setcurrencyListing(values)
            settotalRows(values.length)
        })
    }

    return (
        <Modal open={true} onClose={() => closePage("")} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-7 paddingCenterBox bgTransparent' }}>
            <div className="ws-12 box">

                <div className="ws-12 box">

                    <div className="modal-header box-header-main well">
                        <h2 >Search Currency</h2>
                    </div>

                    <div className="box-content">

                        <div className="ws-5">
                            <div className="form-format">
                                <label className="control-label " >Currency</label>
                                <div className="label-entries">
                                    <input type="text" className="form-control" placeholder="Enter Currency" id="currency" value={searchFor} onChange={(e) => settsearchFor(e.target.value)} />
                                </div>
                            </div>
                        </div>

                        <div className="ws-3 ptl mtxl">
                            <a className="btn btn-small icon-btn edit " style={{ marginTop: "30px;" }} onClick={SearchData}><i className="fa fa-search"></i>Search </a>
                        </div>

                    </div>

                </div>

                <div className="ws-12">

                    <div className="box-header well">
                        <h2> <i className="fa fa-table"></i> <span  >{totalRows} record(s) found</span>  </h2>
                    </div>

                    <div className="box-content">
                        {totalRows === 0 && <div className="alert alert-info">No records to display</div>}
                        <div className="table-responsive">
                            {totalRows > 0 && <table className="newTable" >
                                <thead>
                                    <tr>
                                        <th >Currency</th>
                                        <th >Operation</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        currencyListing.splice(0, 10).map((values: any) => {
                                            return (
                                                <tr>
                                                    <td>{values.territoryCurrency}</td>
                                                    <td>
                                                        <a className="icon-btn info " onClick={() => closePage(values)}><i className="icon-th icon-white"></i>Select</a>
                                                    </td>
                                                </tr>
                                            )
                                        }

                                        )
                                    }
                                </tbody>
                            </table>}
                        </div>

                    </div>

                </div>
            </div>
        </Modal>
    )

}